function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import classnames from 'classnames';
import { AntdTableEmptyPlaceholder } from '../aqe/antd-table-empty-placeholder/antd-table-empty-placeholder';
import { LoadingOutlined } from '@ant-design/icons';
import SwSimpleLinkPagination from '../sw-simple-link-pagination/sw-simple-link-pagination';
import { Table } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { useDataViewContext } from './context';
import { useDataViewSnapshot } from './helpers';
export var DataViewTable = function DataViewTable(props) {
  var _props$locale;
  var _useDataViewContext = useDataViewContext(),
    _useDataViewContext2 = _slicedToArray(_useDataViewContext, 2),
    state = _useDataViewContext2[0],
    dispatch = _useDataViewContext2[1];
  var _useDataViewSnapshot = useDataViewSnapshot({
      includeFilters: true,
      includeTable: true
    }),
    _useDataViewSnapshot2 = _slicedToArray(_useDataViewSnapshot, 2),
    snapshot = _useDataViewSnapshot2[0],
    prevSnapshot = _useDataViewSnapshot2[1];
  var showTableLoadingAnimation = (state.loading || state.dataSourceLoading) && !state.autoRefreshRequested;
  var onTableChange = useCallback(function (pagination, _, sorter, extra) {
    var _props$onChange;
    dispatch({
      type: 'SET_TABLE_STATE',
      data: {
        pagination: pagination,
        sorter: sorter
      }
    });
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, pagination, sorter, extra);
  }, [state.levelResource.level, state.levelResource.id]);
  var onPaginationChange = useCallback(function (_ev, _link, config) {
    var _config$current;
    dispatch({
      type: 'SET_CURRENT_PAGE',
      data: (_config$current = config.current) !== null && _config$current !== void 0 ? _config$current : state.table.pagination.current
    });
  }, [state.levelResource.level, state.levelResource.id, state.table.pagination.current]);
  var setSelectedRowIds = useCallback(function (ids) {
    var _props$onRowSelection;
    (_props$onRowSelection = props.onRowSelectionChanged) === null || _props$onRowSelection === void 0 ? void 0 : _props$onRowSelection.call(props, ids);
    dispatch({
      type: 'SET_SELECTED_IDS',
      data: ids
    });
  }, [state.levelResource.level, state.levelResource.id]);
  var extractRowKey = useCallback(function (row) {
    switch (_typeof(props.rowKey)) {
      case 'string':
        return row[props.rowKey];
      case 'function':
        return props.rowKey(row);
      default:
        return 'id' in row ? row.id : undefined;
    }
  }, [_typeof(props.rowKey)]);
  var visibleIds = state.dataSource.map(function (data) {
    return extractRowKey(data);
  });
  var selectedVisibleIds = state.selectedIds.filter(function (id) {
    return visibleIds.includes(id);
  });
  useEffect(function () {
    if (snapshot !== prevSnapshot) {
      setSelectedRowIds([]);
    }
  }, [snapshot, prevSnapshot]);
  return /*#__PURE__*/React.createElement(Table, _extends({
    locale: _objectSpread({
      emptyText: !props.noData ? undefined : /*#__PURE__*/React.createElement(AntdTableEmptyPlaceholder, {
        text: props.noData.text,
        icon: props.noData.icon
      })
    }, (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : {})
  }, props, {
    className: classnames('data-view-table', props.className, {
      'hide-title': !props.title,
      'hide-pagination': props.hidePagination,
      'hide-actions': props.hideRowActions
    }),
    rowClassName: function rowClassName(record, index, indent) {
      var rowClassName = typeof props.rowClassName === 'function' ? props.rowClassName(record, index, indent) : props.rowClassName;
      return classnames('data-view-row', rowClassName);
    },
    size: "small",
    loading: showTableLoadingAnimation && {
      indicator: /*#__PURE__*/React.createElement(LoadingOutlined, {
        spin: true
      })
    },
    footer: props.hideFooter ? undefined : function (currentTableData) {
      return /*#__PURE__*/React.createElement(SwSimpleLinkPagination, {
        currentTableData: currentTableData,
        links: state.paginationLinks,
        onPrev: onPaginationChange,
        onNext: onPaginationChange
      });
    },
    dataSource: state.dataSource,
    pagination: false,
    onChange: onTableChange,
    rowSelection: !props.rowSelectionEnabled ? undefined : {
      selectedRowKeys: selectedVisibleIds,
      onSelectAll: function onSelectAll(selectAll, _selectedRows, changeRows) {
        var changedIds = changeRows.map(function (s) {
          return extractRowKey(s);
        });
        if (selectAll) {
          var nextIds = [].concat(_toConsumableArray(state.selectedIds), _toConsumableArray(changedIds));
          setSelectedRowIds(nextIds);
        } else {
          var _nextIds = state.selectedIds.filter(function (id) {
            return !changedIds.includes(id);
          });
          setSelectedRowIds(_nextIds);
        }
      },
      onChange: function onChange(_selectedKeys, selectedRows) {
        var nextSelectedIds = selectedRows.map(function (s) {
          return extractRowKey(s);
        });
        var newIds = nextSelectedIds.filter(function (id) {
          return !state.selectedIds.includes(id);
        }).map(function (id) {
          return parseInt(id.toString(), 10);
        });
        var nextIds = [].concat(_toConsumableArray(state.selectedIds.filter(function (id) {
          return nextSelectedIds.includes(id) || !visibleIds.includes(id);
        })), _toConsumableArray(newIds));
        setSelectedRowIds(nextIds);
      }
    }
  }), props.children);
};